document.addEventListener('DOMContentLoaded', () => {
  const relSelector = '#related-swiper .swiper';
  const relEl = document.querySelector(relSelector);
  if (relEl) {
    new Swiper(relSelector, {
      loop: false,
      watchOverflow: true,
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 24 }
      },
      navigation: {
        nextEl: '#related-swiper .rel-swiper-next',
        prevEl: '#related-swiper .rel-swiper-prev'
      }
    });
  }
});
